module.exports = __webpack_public_path__ + "media/images/img-car-7-98debf3b.png";